import { useEffect, useRef } from "react";
import Modal from "../../../../Components/Modal/Modal";
import styles from "./ExpeditionHireEmployeesModal.module.css";
import minus from "/Expeditions/minus.svg";
import plus from "/Expeditions/plus.svg";
import { useModalStore } from "../../../../Store/ModalStore";
import { Expedition } from "../../types";

type HireEmployeesModalProps = {
	employeesCount: number;
	activeTab: null | 3 | 5 | 10;
	expedition: Expedition;
	loading: boolean;
	setEmployeesCount: React.Dispatch<React.SetStateAction<number>>;
	setActiveTab: React.Dispatch<React.SetStateAction<null | 3 | 5 | 10>>;
	handleClaim: (amount: number, id: number) => void;
};

const ExpeditionHireEmployeesModal: React.FC<HireEmployeesModalProps> = ({
	employeesCount,
	activeTab,
	expedition,
	loading,
	setEmployeesCount,
	setActiveTab,
	handleClaim,
}) => {
	const handleClose = useModalStore(state => state.handleClose);

	console.log(employeesCount);

	const inputRef = useRef<HTMLInputElement>(null);
	const currentEmployeesCountRef = useRef<number>(employeesCount);

	const totalCost =
		employeesCount * (expedition?.config?.entry_fee_amount || 0);

	if (employeesCount !== 3 && employeesCount !== 5 && employeesCount !== 10) {
		setActiveTab(null);
	}

	useEffect(() => {
		currentEmployeesCountRef.current = employeesCount;
	}, [employeesCount]);

	const handleChangeQuantity = (action: "plus" | "minus") => {
		if (action === "minus") {
			setEmployeesCount(prev => (prev !== 1 ? prev - 1 : prev));
		} else if (action === "plus" && employeesCount < 999) {
			setEmployeesCount(prev => prev + 1);
		}
	};

	const handleTabClick = (quantity: 3 | 5 | 10) => {
		setEmployeesCount(quantity);
		setActiveTab(quantity);
	};

	useEffect(() => {
		const tg = window.Telegram?.WebApp;
		if (!tg) return;

		tg.MainButton.show();
		tg.setBottomBarColor("#0C0214");

		const handleSubmit = () => {
			handleClaim(currentEmployeesCountRef.current, expedition?.id);
		};

		tg.MainButton.onClick(handleSubmit);

		return () => {
			tg.MainButton.offClick(handleSubmit);
			tg.MainButton.hide();
		};
	}, [handleClose]);

	useEffect(() => {
		const tg = window.Telegram?.WebApp;
		if (!tg) return;

		if (employeesCount === 0) {
			tg.MainButton.disable();
			tg.MainButton.setParams({
				color: "#9b5cf6",
				text_color: "#FFFFFF",
				text: "Выберите количество работников",
			});
			return;
		} else {
			if (loading) {
				tg.MainButton.disable();
				tg.MainButton.setParams({
					color: "#737373",
					text_color: "#FFFFFF",
					text: "Загрузка...",
				});
			} else {
				tg.MainButton.enable();
				tg.MainButton.setParams({
					color: "#7428f5",
					text_color: "#FFFFFF",
					text: `Начать за  ${employeesCount} ⭐`,
				});
			}
		}
	}, [totalCost, loading]);

	useEffect(() => {
		if (inputRef && inputRef.current) {
			inputRef.current.value = "5";
		}
	}, []);

	return (
		<Modal>
			<div
				className={styles.container}
				style={loading ? { pointerEvents: "none" } : {}}
			>
				<div className={styles.info}>
					<h2 className={styles.heading}>Найм работников</h2>
					<p className={styles.description}>1 работник = +1 награда</p>
				</div>

				<div className={styles.quantityContainer}>
					<div
						className={styles.minus}
						onClick={() => handleChangeQuantity("minus")}
					>
						<img src={minus} alt='Minus' />
					</div>

					<div className={styles.inputWrapper}>
						<input
							ref={inputRef}
							type='number'
							min={1}
							className={`${styles.inputNumber} ${
								employeesCount > 9 && employeesCount < 100
									? styles.decimal
									: employeesCount >= 100
									? styles.hundred
									: ""
							}`}
							value={employeesCount === 0 ? "" : employeesCount}
							onChange={e => {
								const val = e.target.value;
								if (val === "") {
									setEmployeesCount(0);
								} else {
									const num = Number(val);
									if (num >= 1 && num <= 999) {
										setEmployeesCount(num);
									}
								}
							}}
						/>
						<img
							src='/Expeditions/user.svg'
							alt='user icon'
							className={styles.inputIcon}
						/>
					</div>

					<div
						className={styles.plus}
						onClick={() => handleChangeQuantity("plus")}
					>
						<img src={plus} alt='Plus' />
					</div>
				</div>

				<div className={styles.tabsContainer}>
					<button
						className={`${styles.tab} ${
							activeTab === 3 || employeesCount === 3 ? styles.tabActive : ""
						}`}
						onClick={() => handleTabClick(3)}
					>
						3
					</button>

					<button
						className={`${styles.tab} ${
							activeTab === 5 || employeesCount == 5 ? styles.tabActive : ""
						}`}
						onClick={() => handleTabClick(5)}
					>
						5
					</button>

					<button
						className={`${styles.tab} ${
							activeTab === 10 || employeesCount == 10 ? styles.tabActive : ""
						}`}
						onClick={() => handleTabClick(10)}
					>
						10
					</button>
				</div>
			</div>
		</Modal>
	);
};

export { ExpeditionHireEmployeesModal };
